'use strict';

angular.module('app.advertiserInfluencerGroup')

.directive('advertiserInfluencerGroupDirective', function () {
        return {
            controller: 'advertiserInfluencerGroupCtrl',
            templateUrl: 'app/sideBarMenu/advertiserInfluencerGroup/advertiserInfluencerGroup.html?app_v=deployDate',
            scope: {}    
        };
})